// src/components/AboutUs.js
import React from 'react';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <h1 className="about-heading">SHADE</h1>
      {/* <h2 className="about-subheading">Riding Together for a Greener Future</h2> */}
      <p className="about-text">
      At SHADE, we believe that commuting is more than just getting from point A to B— it’s about building
      connections and making users get financially benefit out of SHADE. Our vision is to transform everyday
      travel into a shared experience while reducing carbon emissions and easing urban congestion.
      </p>
    </div>
  );
};

export default AboutUs;
